/**
 * @description: 中文说明
 * @author: zb
 * @update: zb
 * @Date: 2019-05-29 10:41:33
 * @LastEditors: zb
 * @LastEditTime: 2019-05-29 10:41:33
 */
/*
 * @description: 中文说明
 * @author: zb
 * @update: zb
 * @Date: 2019-05-27 16:27:32
 * @LastEditors: zb
 * @LastEditTime: 2019-05-27 18:21:42
 */
export const goodsTableHeader = [
  {
    label: '收货地址',
    slot: 'path',
    align: 'center',
    width: '220'
  },
  {
    label: '货物信息',
    align: 'center',
    prop: 'goodsDescription'
  },
  {
    label: '货物种类',
    align: 'center',
    prop: 'goodsType'
  },
  {
    label: '发布时间',
    align: 'center',
    prop: 'createDate'
  },
  {
    label: '操作',
    // 绑定的 卡槽名称
    slot: 'operation',
    align: 'center',
    width: '200',
    fixed: 'right'
  }
]
export const goodsTableHeader1 = [
  // ？？？？lihc
  {
    label: '运输路径',
    slot: 'place',
    width: '200'
  },
  {
    label: '运输时效',
    prop: 'transportTimeliness'
  },
  {
    label: '运输价格',
    prop: 'contact'
  },
  {
    label: '联系电话',
    prop: 'price'
  },
  {
    label: '发布时间',
    prop: 'price'
  },
  {
    label: '操作',
    // 绑定的 template slot name
    slot: 'operation',
    align: 'center',
    width: '200',
    fixed: 'right'
  }
]
